import i18n, { t } from "i18next";
import {
    BuildingModalIcon,
    DescriptionTittle,
    DetailsIconsOptions,
    DownloadIcon, IconLoadingNotification
} from "../../../../components/buttons/IconButtons";
import { getModelKeyById } from "../../../../Apis/Models";
import { Trans } from "react-i18next";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import routes from "../../../../Routes/routes";
import { DownloadReportByName } from "../../../../reduxToolkit/Reports/ReportApi";
import { toast } from "react-toastify";
import { TABS_VISITOR } from "../../Visitor/Model/Model";
import { VISITOR_SUB_VIEW_MODEL } from "../../Visitor/Invitation/Model/Model";
import {calculateTime} from "../../../../Apis/functions";
import {errorCodeTranslation} from "../../../../Apis/ErrorCode";
import {status} from "../../../../enums/statusEnum";
import {STATUS_MODEL} from "../../../../enums/statusEnum";

/**
 * @typedef {Object} NotificationItem
 * @property {number} id - Unique identifier for the notification.
 * @property {string} translation - Translation key associated with the notification type.
 * @property {JSX.Element | null} icon - Icon to display (can be a React component or null).
 */

/**
 * List of available notification items.
 * @type {NotificationItem[]}
 */

export const NOTIFICATION_TABS_MODEL = {
    ALL: {
        id: 1,
        name: "ALL"
    },
    REPORTS: {
        id: 2,
        name: "REPORTS"
    },
    VISITORS: {
        id: 3,
        name: "VISITORS"
    }
};

export const NOTIFICATION_ITEM_MODEL = {
    ALL: {
        ...NOTIFICATION_TABS_MODEL.ALL
    },
    REPORTS: {
        ...NOTIFICATION_TABS_MODEL.REPORTS,
        key: "REPORTS",
        icon: <DescriptionTittle className="h-20px w-20px" />,
        title: "",
        elementName: "",
        description: "",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-primary-500 background-primary-100",
        iconClass: "background-primary-100",
        getButton: ({ dispatch, value, handleToggle }) => {
            return <ButtonAction
                Icon={DownloadIcon}
                iconProps="mx-1"
                name={"DOWNLOAD_DOCUMENT"}
                splitName={false}
                className="btn-background-transparent-shades-300 btn-no-shadow"
                onClick={() => {
                    handleToggle();
                    dispatch(DownloadReportByName({ name: value })).then(
                        ({ payload: { data: { success } } }) => {
                            if (success === true) {
                                toast.success(t("has_been_downloaded_successfully"));
                            }
                        }
                    );
                }
                }
            />
        },

    },
    REQUEST_ACCESS: {
        ...NOTIFICATION_TABS_MODEL.VISITORS,
        key: "REQUEST_ACCESS",
        icon: <BuildingModalIcon className="h-20px w-20px" />,
        title: "visitor_access_request",
        elementName: "",
        description: "has_request_access_review_and_approve_the_request",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-secondary-500 background-secondary-100",
        iconClass: "background-secondary-100",
        getButton: ({ navigate, handleToggle }) => {
            return <ButtonAction
                Icon={DetailsIconsOptions}
                name={"review_requests"}
                splitName={false}
                className="btn-background-transparent-shades-300 btn-no-shadow"
                onClick={() => {
                    handleToggle();
                    navigate(routes.visitor.list, {
                        state: { currentTab: TABS_VISITOR.VISITORS.INDEX, currentSubView: VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS },
                    });
                }}
            />
        }
    },
    USER_INVITATION: {
        ...NOTIFICATION_TABS_MODEL.VISITORS,
        key: "USER_INVITATION",
        icon: <BuildingModalIcon className="h-20px w-20px" />,
        title: "your_visitor_has_arrived",
        elementName: "",
        description: "is_at_reception_and_ready_to_enter",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-warning-500 background-warning-100",
        iconClass: "background-warning-100",
        getButton: null,
    },
    sort: function (list) {
        if (!list) return list;
        return list?.sort((a, b) => new Date(b.orderTime) - new Date(a.orderTime));
    },
    set: function (data, key) {
        let getButton = this[key].getButton;
        let title = i18n.t(this[key].title);
        let value = i18n.t(this[key].value);
        let read;
        let description;
        let orderTime;
        let icon;

        if (key === NOTIFICATION_ITEM_MODEL.REPORTS.key) {
            read = data.isFileViewed;
            let reportName = i18n.t(getModelKeyById(data.moduleId));
            title = i18n.t(status[data.statusId], { name: reportName });
            value = data?.path;
            orderTime = data.endAt;

            if(data?.statusId === STATUS_MODEL.REPORT_GENERATING){
                getButton = null;
                description = <Trans
                    i18nKey={"your_report_is_generating"}
                    values={{ name: reportName }}
                />
                icon = <IconLoadingNotification className="icon-color-general-950 btn-icon-svg-20px loader" />
                orderTime = data.startAt;
            }else if(data?.statusId === STATUS_MODEL.REPORT_EXPIRED){
                getButton = null;
                description = <Trans
                    i18nKey={"your_report_is_expired"}
                    values={{ name: value }}
                    components={{ bold: <strong /> }}
                />
                icon = <DescriptionTittle className="btn-icon-svg-20px" />
                orderTime = data.startAt;
            }else {
                if (errorCodeTranslation[data.path]) {
                    getButton = null;
                    description = <Trans
                        i18nKey={errorCodeTranslation[data.path]}
                        values={{ name: reportName }}
                    />
                    icon = <DescriptionTittle className="btn-icon-svg-20px" />
                } else {
                    description = <Trans
                        i18nKey="your_report_is_ready"
                        values={{ name: value }}
                        components={{ bold: <strong /> }}
                    />;
                    icon = <DescriptionTittle className="btn-icon-svg-20px" />
                }
            }
        } else if (key === NOTIFICATION_ITEM_MODEL.USER_INVITATION.key) {
            read = data.isViewed === 2;//Readed value to user invitation
            orderTime = data.updatedAt;
            description = <Trans
                i18nKey={this[key].description}
                values={{ name: data?.visitorName + " " + data?.visitorLastName + (data?.visitorSecondLastName ? (" " + data?.visitorSecondLastName) : "") }}
                components={{ bold: <strong /> }}
            />;
            icon = <BuildingModalIcon className="btn-icon-svg-20px" />
        } else {
            read = data.isViewed === 1;//Readed value to request access
            orderTime = data?.actionTakenAt || data?.createdAt;
            description = <Trans
                i18nKey={this[key].description}
                values={{ name: data?.requestedByName + " " + data?.requestedByLastName + (data?.requestedBySecondLastName ? (" " + data?.requestedBySecondLastName) : "") }}
                components={{ bold: <strong /> }}
            />;
            icon = <BuildingModalIcon className="btn-icon-svg-20px" />
        }

        return {
            ...this[key],
            title: title,
            id: data.id,
            elementName: "",
            description: description,
            elapsedTime: calculateTime(orderTime),
            orderTime: orderTime,
            getButton: getButton,
            value: value,
            read: read,
            icon,
            readIndicatorClass: read ? this[key].readIndicatorClass : this[key].unreadIndicatorClass
        }
    },
}

export const notificationsItems = [
    {
        id: NOTIFICATION_TABS_MODEL.ALL.id,
        key: NOTIFICATION_TABS_MODEL.ALL.name,
        translation: "all",
        icon: null
    },
    {
        id: NOTIFICATION_TABS_MODEL.REPORTS.id,
        key: NOTIFICATION_TABS_MODEL.REPORTS.name,
        translation: "reports",
        icon: <DescriptionTittle className="btn-icon-svg-20px" />,
    },
    {
        id: NOTIFICATION_TABS_MODEL.VISITORS.id,
        key: NOTIFICATION_TABS_MODEL.VISITORS.name,
        translation: "visitors",
        icon: <BuildingModalIcon className="btn-icon-svg-20px" />,
    },
];


export const ALLOWED_NOTIFICATION_ROUTES = [
    "dashboard/employee",
    "dashboard/contractor",
    "dashboard/supplier",
    "login-option"
]
